// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonZoomZoomMinus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.00006 5V5.99997H7.99744V5H3.00006Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.75766 7.99983C1.27909 7.28481 1 6.425 1 5.5C1 3.01472 3.01472 1 5.5 1C7.98528 1 10 3.01472 10 5.5C10 6.40594 9.73229 7.24935 9.27167 7.95544L12.0001 11.293L11.2936 12.0001L7.95893 9.26939C7.25213 9.73141 6.40743 10 5.5 10C5.42233 10 5.34511 9.99803 5.2684 9.99414C3.80372 9.92128 2.52353 9.14692 1.75635 7.99983H1.75766ZM5.31836 8.99537C5.37697 8.99829 5.43597 8.99977 5.4953 8.99977C6.88949 8.99977 8.09374 8.18254 8.65496 6.99986H8.66325C8.87918 6.54527 9 6.03674 9 5.5C9 3.567 7.433 2 5.5 2C3.567 2 2 3.567 2 5.5C2 7.37207 3.46978 8.90086 5.31836 8.99537Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.9989 6H2.99894V8H10.9989V6Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 2.10734e-07 3.13401 0 7C2.10734e-07 10.866 3.13401 14 7 14ZM6.99894 12C9.76037 12 11.9989 9.76142 11.9989 7C11.9989 4.23858 9.76037 2 6.99894 2C4.23752 2 1.99894 4.23858 1.99894 7C1.99894 9.76142 4.23752 12 6.99894 12Z" class="svg-bg"/>
  <path d="M11.7574 13.8789L13.8787 11.7576L16 15.2931L15.2929 16.0002L11.7574 13.8789Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.00002 8.99998V11H14L14 8.99998H6.00002Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.364 16.364C19.8787 12.8492 19.8787 7.15076 16.364 3.63604C12.8492 0.12132 7.15076 0.12132 3.63604 3.63604C0.12132 7.15076 0.12132 12.8492 3.63604 16.364C7.15076 19.8787 12.8492 19.8787 16.364 16.364ZM14.9497 14.9497C17.6834 12.2161 17.6834 7.78392 14.9497 5.05025C12.2161 2.31658 7.78392 2.31658 5.05025 5.05025C2.31658 7.78392 2.31658 12.2161 5.05025 14.9497C7.78392 17.6834 12.2161 17.6834 14.9497 14.9497Z" class="svg-bg"/>
  <path d="M19.1924 16.364L22.7279 21.3137L21.3137 22.7279L16.364 19.1924L19.1924 16.364Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonZoomZoomMinus is a generated icon component.
 */
let IconCommonZoomZoomMinus = IconCommonZoomZoomMinus_1 = class IconCommonZoomZoomMinus extends IconBaseElement {
    render() {
        return html `${IconCommonZoomZoomMinus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonZoomZoomMinus.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonZoomZoomMinus = IconCommonZoomZoomMinus_1 = __decorate([
    customElement('zui-icon-common-zoom-zoom-minus')
], IconCommonZoomZoomMinus);
export { IconCommonZoomZoomMinus };
